// In-progress study session persistence (per-tab, survives navigation).
const KEY = "kb_study_session_v1";

export function saveStudySession(session) {
  try { sessionStorage.setItem(KEY, JSON.stringify(session)); } catch (e) { /* storage disabled */ }
}

export function loadStudySession() {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

export function clearStudySession() {
  try { sessionStorage.removeItem(KEY); } catch (e) { /* storage disabled */ }
}
